import React from "react";
import { useTranslation } from "react-i18next";
// import Layout from "../../layouts/Layout";

const Vaccination = () => {
  const { t } = useTranslation("vaccination");

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t("title")}
          </h1>
          <p className="text-gray-600">{t("description")}</p>
        </div>

        {/* 所有人 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("everyone.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("everyone.flu.title")}
                </h3>
                <p className="text-gray-600">{t("everyone.flu.description")}</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("everyone.covid.title")}
                </h3>
                <p className="text-gray-600">
                  {t("everyone.covid.description")}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 65歲以上 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("over65.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("over65.pneumococcal.title")}
                </h3>
                <p className="text-gray-600">
                  {t("over65.pneumococcal.description")}
                  <br />
                  {t("over65.pneumococcal.description_2")}
                  <br />
                  {t("over65.pneumococcal.description_3")}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("over65.rsv.title")}
                </h3>
                <p className="text-gray-600">
                  {t("over65.rsv.description")}
                </p>
                <p className="text-gray-800 mt-2">{t("over65.rsv.evidence")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* 60-64歲 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("ages60to64.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages60to64.pneumococcal.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages60to64.pneumococcal.description")}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages60to64.rsv.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages60to64.rsv.description")}
                </p>
                <p className="text-gray-800 mt-2">{t("ages60to64.rsv.evidence")}</p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages60to64.shingles.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages60to64.shingles.description")}
                </p>
                <p className="text-gray-800 mt-2">{t("ages60to64.shingles.evidence")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* 51-60歲 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("ages51to60.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages51to60.pneumococcal.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages51to60.pneumococcal.description")}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages51to60.shingles.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages51to60.shingles.description")}
                </p>
                <p className="text-gray-800 mt-2">{t("ages51to60.shingles.evidence")}</p>
              </div>
            </div>
          </div>
        </section>

        {/* 18-50歲 */}
        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("ages18to50.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("ages18to50.pneumococcal.title")}
                </h3>
                <p className="text-gray-600">
                  {t("ages18to50.pneumococcal.description")}
                  <br />
                  {t("ages18to50.pneumococcal.description_2")}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-12">
          <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-green-900 mb-4">
              {t("under18.title")}
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  {t("under18.pertussis.title")}
                </h3>
                <p className="text-gray-600">
                  {t("under18.pertussis.description")}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Vaccination;
